import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        pageTitle: {
            marginBottom: '15px !important',
            fontWeight: '600 !important',
            fontSize: '24px !important',
            lineHeight: '24px !important',
        },
        goalRaised: {
            fontSize: '24px !important',
            lineHeight: '28px !important',
            color: '#333'
        },
        lazyLoadDiv: {
            padding: '0 15px 0 15px',
            '& span': {
                display: 'flex !important',
                alignItems: 'center',
            },
            backgroundImage: `url(${require('../../../../assets/images/loader.gif')})`,
            width: '100%',
            height: '100%',
            backgroundSize: '50px 50px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            margin: '10px 0 15px 0'
        },
        donationInfo: {
            marginTop: '5px !important',
            color: theme.palette.neutral.main
        },
        productImapact: {
            margin: '5px 0px 5px 0',
            color: theme.palette.neutral.main
        },
        donationButtonsDiv: {
            margin: '30px 0 30px 0',
            position: 'fixed',
            bottom: '0',
            zIndex: '100',
            backgroundColor: '#fff',
            padding: '15px',
            boxShadow: '0px -3px 5px #eee',
            marginBottom: '0',
            display: 'flex',
        },
        donationListContainer: {
            width: '100%'
        },
        donationsList: {
            maxHeight: '240px',
            overflowY: 'auto',
        },
        shareButton: {
            color: 'black !important',
            fontWeight: 'bold !important',
            fontSize: '1rem'
        },
        sectionSeparator: {
            margin: '30px 0 30px 0 !important',
            backgroundColor: '#f4f4f5',
            height: '10px',
            border: 'none !important',
            boxShadow: 'inset 0px 0px 5px #d4d5d9'
        },
        consistentPadding: {
            padding: '0 15px 0 15px'
        },
        changeDonationTabButton: {
            margin: '0 15px 0 15px !important'
        },
        editLink: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: '15px !important',
            marginTop: '30px !important'
        }
    }),
);

export default useStyles;